import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import IconButton from "@mui/material/IconButton";

import { activateBell, deactivateBell } from "../../../actions/projectmail";

const NotificationBellComponent = ({ type, bellActive, activateBellFn, deactivateBellFn }) => {
  const [hasbell] = useState(type !== "closed" && type !== "ticketHistory");
  return hasbell ? (
    <div>
      {bellActive ? (
        <IconButton onClick={() => deactivateBellFn(type)} size="large">
          <NotificationsIcon />
        </IconButton>
      ) : (
        <IconButton onClick={() => activateBellFn(type)} size="large">
          <NotificationsOffIcon />
        </IconButton>
      )}
    </div>
  ) : null;
};

NotificationBellComponent.propTypes = {
  type: PropTypes.string.isRequired,
  bellActive: PropTypes.bool.isRequired,
  activateBellFn: PropTypes.func.isRequired,
  deactivateBellFn: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  bellActive: state.projectmail.activeBellsForTicketType.indexOf(ownProps.type) > -1,
});

const mapDispatchToProps = dispatch => ({
  activateBellFn: type => dispatch(activateBell(type)),
  deactivateBellFn: type => dispatch(deactivateBell(type)),
});

const NotificationBell = connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationBellComponent);

export default NotificationBell;
